export const InfoCard = [
  { title: "Name:", text: "Chadwin Allotey", id: 1 },
  { title: "Email:", text: "chadwin.allotey@gmail.com", id: 2 },
  { title: "Date of birth:", text: "29 October,1993", id: 3 },
  { title: "From:", text: "Mississauga, ON.", id: 4 },
];
export default InfoCard;
